'use strict';

const SiteValues = {
  ww: () => { return window.innerWidth ? window.innerWidth : window.outerWidth; },
  wh: () => { return window.innerHeight ? window.innerHeight : window.outerHeight; },
  dh: () => {
    let v=Math.max.apply(null,[document.body.clientHeight,document.body.scrollHeight,document.documentElement.scrollHeight,document.documentElement.clientHeight]);
    return v;
  },
  st: () => { return window.scrollY; },
  hh: () => { return document.querySelector('.header').offsetHeight; },
  ua:navigator.userAgent
};

const isMobile = () => { return SiteValues.ww() <= 768 ? true : false; };
const isDesktop = () => { return SiteValues.ww() >= 769 ? true : false; };
const isTouch = () => { return (SiteValues.ua.indexOf('iPhone') >1 || SiteValues.ua.indexOf('iPad') >1 || SiteValues.ua.indexOf('Android') > 1) ? true : false; };

if (isTouch()) {
  document.body.classList.add('u-device-touch');
} else {
  document.body.classList.add('u-device-click');
};

class fadeToggle {
  constructor($target, duration = 400, delay = 40) {
    if (window.getComputedStyle($target).display === 'none') {
      this._fadeIn($target,duration,delay);
    } else {
      this._fadeOut($target,duration,delay);
    };
  };
  _fadeOut = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.opacity = 1.0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity -= coef;
      el.style.opacity = opacity;
      if (opacity <= 0) {
        el.style.display = 'none';
        clearInterval(animation);
      };
    }, delay);
  };
  _fadeIn = (el, duration, delay) => {
    const coef = 1 / (duration / delay);
    el.style.display = 'block';
    el.style.opacity = 0;
    let opacity = Number(el.style.opacity);
    const animation = setInterval(() => {
      opacity += coef;
      el.style.opacity = opacity;
      if (opacity >= 1) {
        clearInterval(animation);
      };
    }, delay);
  };
};

class slideToggle {
  constructor($target, duration = 400) {
    if (window.getComputedStyle($target).display === 'none') {
      this._slideDown($target, duration);
    } else {
      this._slideUp($target, duration);
    };
  };
  _slideUp = (el, duration) => {
    el.style.height = el.offsetHeight+'px';
    el.offsetHeight;
    el.style.transitionProperty = 'height,margin,padding';
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
  _slideDown = (el, duration) => {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty='height,margin,padding';
    el.style.height = `${height}px`;
    el.style.transitionDuration = `${duration}ms`;
    el.style.transitionTimingFunction = 'ease';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
      el.style.removeProperty('transition-timing-function');
    }, duration);
  };
};

class pageScroll {
  constructor($trigger, behavior) {
    let $tiggers = document.querySelectorAll($trigger);
    if ($tiggers.length) {
      $tiggers.forEach($this => {
        $this.addEventListener('click', event => {
          event.preventDefault();
          let hash = $this.getAttribute('href');
          hash = hash.replace(/^#([\d\D]+)/, '$1');
          let $hash = document.getElementById(hash);
          if ($hash) $hash.scrollIntoView({ behavior:behavior });
        });
      });
    };
  };
};

new pageScroll('a[href^="#"]','smooth');

class layoutFooter {
  constructor ($t) {
    this.$t = document.querySelector('.l-ft');
    this.$pagetop = document.querySelector('.l-ft-pagetop');

    if (this.$pagetop){
      this._pagetop();
      window.addEventListener('resize', this._pagetop);
      window.addEventListener('scroll', this._pagetop);
    };
  };
  _pagetop = () => {
    let st = SiteValues.st();
    let wh = SiteValues.wh();
    let top = this.$t.getBoundingClientRect().top;
    if (st > wh) {
      this.$pagetop.classList.add('is-show');
      if (top - wh < 0) {
        this.$pagetop.classList.add('is-stayed');
      } else {
        this.$pagetop.classList.remove('is-stayed');
      };
    } else {
      this.$pagetop.classList.remove('is-show');
    };
  };
};

const $layoutFooter = document.querySelectorAll('.l-ft');
if ($layoutFooter) {
  new layoutFooter();
};
